import BrandFansGroupMemberList from './List'

export default BrandFansGroupMemberList
